import { Component, OnInit } from '@angular/core';
export class ProfileSeparatorComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[hd-profile-separator]',
  template: `
  `,
  styles: [`
        :host{
            margin: 15px 0;
            margin-left: -20px;
            margin-right: -20px;
            border-bottom: 1px solid #f4f5f8;
            height: 0;
            overflow: hidden;
        }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ProfileSeparatorComponent_tsickle_Closure_declarations() {
/** @type {?} */
ProfileSeparatorComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ProfileSeparatorComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
